var React = require('react');

function BoardViewSmall (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6 12a1.033 1.033 0 01-.71-.29A.99.99 0 015 11V1a1.033 1.033 0 01.29-.71A.99.99 0 016 0a1.033 1.033 0 01.71.29A.99.99 0 017 1v10a.99.99 0 01-1 1zM2 8a1.033 1.033 0 01-.71-.29A.99.99 0 011 7V1a1.033 1.033 0 01.29-.71A.99.99 0 012 0a1.033 1.033 0 01.71.29A.99.99 0 013 1v6a.99.99 0 01-1 1zm8-4a1.033 1.033 0 01-.71-.29A.99.99 0 019 3V1a1.033 1.033 0 01.29-.71A.99.99 0 0110 0a1.033 1.033 0 01.71.29A.99.99 0 0111 1v2a.99.99 0 01-1 1z","key":0}),React.createElement("path",{"fill":"none","d":"M0 0h12v12H0z","key":1})]);
}

BoardViewSmall.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","className":"css-1s665wz"};

module.exports = BoardViewSmall;

BoardViewSmall.default = BoardViewSmall;
